<template>
  <div class="tab_content tab__more_information">
    <div class="more_information__note vx-row items-center mx-2">
      <!-- <h3 class="mr-2">More Information</h3> -->
    </div>

    <!-- form - more information -->
    <div class="vx-row px-5">
      <!-- col - 1 -->
      <div class="vx-col w-full">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <!-- Discount Dropdown -->
          <div>
            <label>Discount Type</label>
            <select-2
              autocomplete
              class="w-full"
              v-model="form.taxDiscountId"
              @input="(item) => (form.taxDiscountId = item && item.value)"
              label-placeholder="Discount Type"
              name="Discount Type"
              placeholder="Select Discount Type"
              :options="systemDiscountTypeOptions"
            />
          </div>

          <div>
            <label>Phone Number</label>
            <vs-input v-model="form.phone" icon="icon icon-list" icon-pack="feather" class="w-full" name="Phone Number" v-validate="'required'" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Phone Number')">{{ errors.first('Phone Number') }}</span> -->
          </div>
          <div>
            <label for="Email">Email</label>
            <vs-input type="email" v-model="form.email" icon="icon icon-list" icon-pack="feather" class="w-full" name="Email" v-validate="'required'" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span> -->
          </div>
          <div>
            <label for="Address">Address</label>
            <vs-input v-model="form.address" icon="icon icon-list" icon-pack="feather" class="w-full" name="Address" v-validate="'required'" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span> -->
          </div>
          <div>
            <label for="State">State</label>
            <vs-input v-model="form.state" icon="icon icon-list" icon-pack="feather" class="w-full" name="State" v-validate="'required'" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('State')">{{ errors.first('State') }}</span> -->
          </div>
          <div>
            <label for="City">City</label>
            <select-2 :ssr="false" class="w-full" v-model="form.cityId" @input="(item) => (form.cityId = item && item.value)" placeholder="Please Select City" :options="citiesOptions" />
          </div>
          <div>
            <label for="Zip Code">Zip Code</label>
            <vs-input icon="icon icon-map-pin" v-model="form.postcode" icon-pack="feather" class="w-full" name="Zip Code" />
          </div>
          <!-- date of birth -->
          <div>
            <label for="">DOB</label>
            <date-picker :appendToBody="false" v-model="form.dob" placeholder="MM-DD-YYYY" format="MM-DD-YYYY" valueType="format" class="w-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { dateMixins } from '@/mixins/dateMixins.js'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'MoreInformationTab',
  components: {
    Select2,
    DatePicker
  },
  props: {
    form: {
      type: Object
    }
  },

  data: () => ({
    citiesOptions: [],
    dateFormat: 'MM-DD-YYYY'
  }),

  mixins: [dateMixins],

  async mounted() {
    await this.get_cities_options() // get city options
    await this.getDiscountAndTaxOptions() // get discount and tax options
  },

  computed: {
    ...mapState('setting', ['loading', 'systemDiscountAndTax', 'userDiscountAndTax']),

    // system discount type options
    systemDiscountTypeOptions() {
      return this.systemDiscountAndTax.reduce((acc, item) => {
        acc.push({
          label: item.name,
          value: item.id
        })

        return acc
      }, [])
    },

    // user discount type options
    userDiscountTypeOptions() {
      return this.userDiscountAndTax.reduce((acc, item) => {
        acc.push({
          label: item.name,
          value: item.id
        })

        return acc
      }, [])
    }
  },
  methods: {
    ...mapActions({ fetch_city_options: 'getCityOptions' }),
    ...mapActions('setting', ['getSystemDiscountAndTax']),

    async getDiscountAndTaxOptions() {
      const payload = { page: 1, limit: 0, search: null, order: ['tax_and_discount.id', 'ASC'], type: ['system', 'user'] }
      await this.getSystemDiscountAndTax(payload)
    },

    // get city options
    async get_cities_options() {
      try {
        const { data } = await this.fetch_city_options({ search: '' })
        this.citiesOptions = data
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  }
}
</script>

<style>
[dir] .con-vs-tabs {
  overflow: visible;
}
[dir] .con-slot-tabs {
  overflow: visible;
}
.input-bod .vs-inputx {
  padding: 7px !important;
}
</style>
